import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../service/language.service';

@Pipe({
    name: 'bool-text',
    standalone: false
})
export class BooleanTextPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}

  transform(value: any, ...args: any[]) {
    if (typeof value === typeof true) {
      return value ? 'YES_TEXT' : 'NO_TEXT';
    }
    return value;
  }

  toBoolean(value: string): boolean {
    const yesText = this.languageService.instant('YES_TEXT');
    const noText = this.languageService.instant('NO_TEXT');
    switch (value) {
      case yesText:
        return true;
      case noText:
        return false;
      default:
        return false;
    }
  }
}
